import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { ALLOWED_LINK_PLATFORMS } from './constants'

const schema = z.object({
  name: z.string().min(1, { message: 'Name is required.' }),
  website: z
    .string()
    .url({ message: 'Invalid URL' })
    .refine(
      (value) => {
        try {
          const domain = new URL(value).hostname

          return ALLOWED_LINK_PLATFORMS.some((platform) =>
            domain.includes(platform),
          )
        } catch {
          return false
        }
      },
      { message: 'This website is not supported' },
    ),
  country: z.string().min(1, { message: 'Country is required.' }),
  onlyFansUser: z.boolean(),
})

export const prospectFormResolver = zodResolver(schema)

export type ProspectFormValues = z.infer<typeof schema>
